<template>
  <div>
    <div class="jumbotron">
      <div class="container marketing">
        <div class="row ">
          <div class="col-lg-8 col-xs-10"
               style="width:90%;background: #FFFFFF;padding:5%;border-radius: 5px;margin: 5%">
            <div>
              <el-row>
                <el-form ref="form" :model="form" label-width="50px" size="mini">
                  <el-form-item label="产品" prop="productId">
                    <el-select v-model="form.productNumber"
                               placeholder="请选择">
                      <el-option
                          v-for="dict in productIdOptions"
                          :key="dict.id"
                          :label="dict.productName"
                          :value="dict.productNumber"
                      />
                    </el-select>
                  </el-form-item>
                </el-form>
              </el-row>

              <!--              码显示区-->
              <div style="min-height: 50px">
                <div style="margin: 15px;text-align: center" v-show="resData.is_none===true">
                  <h5 style="color: red">{{ resData.code }} 未查询到相关数据</h5>
                </div>
                <div style="margin: 15px" v-show="resData.big.length>0">
                  <h5>大标</h5>
                  <ul>
                    <li v-for="item in resData.big" :key="item">{{ item }}</li>
                  </ul>
                </div>
                <div style="margin: 15px" v-show="resData.mid.length>0">
                  <h5>中标</h5>
                  <ul>
                    <li v-for="item in resData.mid" :key="item">{{ item }}</li>
                  </ul>
                </div>
                <div style="margin: 15px" v-show="resData.small.length>0">
                  <h5>小标</h5>
                  <ul>
                    <li v-for="item in resData.small" :key="item">{{ item }}</li>
                  </ul>
                </div>
              </div>

              <el-row style="margin-top: 10px" type="flex" justify="end">
                <el-col :span="8">
                  <a-button type="primary" size="small" @click.native="scanCode">扫码查询</a-button>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import {getProductList, QueryBindData} from "../api/data_bind";

export default {
  data() {
    return {
      productIdOptions: [],
      bigLen: [],
      midLen: [],
      smallLen: [],
      restaurants: [],
      timeout: null,
      form: {
        productNumber: "",
      },
      resData: {
        big: [],
        mid: [],
        small: [],
        is_none: false,
      },
    };
  },
  created() {
    this.products();
    if (this.$store.state.queryDataBindProductNumber !== '') {
      this.form.productNumber = this.$store.state.queryDataBindProductNumber
    }
    // 加载缓存
    // 获取扫码数据
    this.bigLen = this.$store.state.codeLen.big
    this.midLen = this.$store.state.codeLen.mid
    this.smallLen = this.$store.state.codeLen.small
    if (this.$store.state.pre !== 'fromScan') {
      return
    }
    if (this.$store.state.code !== '') {
      this.freshCode()
    }
    this.$store.commit("setPre", '')
  },
  mounted() {
  },
  watch: {
    "form.productNumber": {
      handler: function () {
        this.$store.commit("setQueryDataBindProductNumber", this.form.productNumber)
      }
    },
  },
  computed: {
    formItemLayout() {
      const {layout} = this.form;
      return layout === "horizontal"
          ? {
            labelCol: {span: 4},
            wrapperCol: {span: 14},
          }
          : {};
    },
    buttonItemLayout() {
      const {layout} = this.form;
      return layout === "horizontal"
          ? {
            wrapperCol: {span: 14, offset: 4},
          }
          : {};
    },
  },
  methods: {
    products() {
      getProductList({}).then((res) => {
        if (res.code == 200) {
          this.productIdOptions = res.data.list
        }
      });
    },

    scanCode() {
      if (this.form.productNumber === '') {
        this.$message.error('请选择产品');
        return
      }
      this.$store.commit("setQueryDataBindProductNumber", this.form.productNumber)

      if (this.$store.state.isDev) {
        this.$store.commit("setScanCode", "89898990")
        this.freshCode()
        return;
      } else {
        this.$router.push({
          path: '/scanCodePage'
        });
      }
    },
    freshCode() {
      const c = this.$store.state.code;
      this.QueryBindDataApi({
        "product_number": this.form.productNumber,
        "code_number": c,
      })
    },
    QueryBindDataApi(params) {
      QueryBindData(params).then((res) => {
        if (res.code == 200) {
          this.$message.success(res.msg)
          this.resData = res.data
        }
      });
    }
  },
}
;
</script>
<style scoped>
.marketing {
  margin-top: 50px;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.demonstration {
  display: block;
  color: #8492a6;
  font-size: 14px;
  margin-bottom: 20px;
}

/deep/ .el-input {
  width: 220px;
  font-size: 11px;
}

::v-deep .el-autocomplete-suggestion {
  min-width: 200px;
  width: auto !important;
}

/deep/ .el-table .el-table__cell {
  padding: 1px;
  min-width: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-overflow: ellipsis;
  vertical-align: middle;
  position: relative;
  text-align: left;
}

</style>